
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12697',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12697",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9769",
  "foundations-components": "static-1.8140",
  "foundations-components-legacy": "static-1.1165",
  "foundations-theming": "static-1.4537",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8125",
  "hub-http-shared-msw-handlers": "static-1.10219",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11582",
  "I18n": "static-7.1636",
  "jasmine-runner": "static-1.6565",
  "marketplace-storefront-base": "static-1.12760",
  "quartz": "static-1.7163",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16789",
  "reactive-variable-buffer-atom": "static-1.2965",
  "reporting-testing-lib": "static-1.9905",
  "settings-ui-lib": "static-1.12627",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7329",
  "ui-addon-i18n": "static-1.11256",
  "ui-addon-react-router-dom": "static-1.9645",
  "unified-auth": "static-1.619",
  "unified-auth-core-lib": "static-1.901",
  "usage-tracker": "static-1.7456",
  "usage-tracker-core": "static-1.7306",
  "customer-data-property-utils": "static-1.8202",
  "hub-http": "static-1.6330",
  "integrations-lib": "static-1.16492",
  "marketplace-ui-common": "static-1.20126",
  "property-management-iframe": "static-1.13518",
  "quartz-config": "static-1.941",
  "quartz-core": "static-1.6382",
  "quartz-routing": "static-1.593",
  "quick-fetch": "static-1.3995",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4763",
  "ts-schema": "static-1.4158",
  "ui-universal-auth": "static-1.9105",
  "UIComponents": "static-3.8528",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3475",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3440",
  "quartz-webpack": "static-1.3387",
  "bend-plugin-quartz-routing": "static-1.241",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4409",
  "floating-ui": "static-1.57",
  "foundations-assets": "static-1.4980",
  "foundations-theming-specialty": "static-1.2253",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9529",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.34",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5420",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2183",
  "ui-fonts": "static-1.844",
  "ui-images": "static-2.1179",
  "bend-plugin-foundations-theming": "static-1.3020",
  "foundations-theming-base": "static-1.3522",
  "stylex": "static-1.34",
  "HeadJS": "static-2.767",
  "hs-test-utils-bend-plugin": "static-1.3236",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4433",
  "ai-components-ui-library": "static-1.9214",
  "ai-rendering-library": "static-1.10541",
  "chirp-fetch": "static-1.1994",
  "connections-embed-lib": "static-1.1187",
  "copilot-toolkit": "static-1.11401",
  "feedback-loader": "static-1.29492",
  "laboratory-lib": "static-3.7259",
  "marketplace-embed": "static-1.22421",
  "marketplace-ui-details": "static-1.10021",
  "marketplace-ui-reviews": "static-1.20081",
  "marketplace-ui-tracking": "static-1.14296",
  "sanitize-text": "static-1.8252",
  "ui-addon-video-player": "static-1.8810",
  "usage-tracker-multi": "static-1.5870",
  "usage-tracker-session-replay": "static-1.5142",
  "wootric-nps": "static-1.7061",
  "quartz-head": "static-1.828",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4759",
  "immer": "static-1.33",
  "immerable": "static-1.4258",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2564",
  "reporting-data": "static-1.67972",
  "cssUtils": "static-1.822",
  "flux-actions": "static-1.345",
  "HubStyle": "static-2.11889",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10315",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10469",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7446",
  "icons": "static-2.653",
  "marketplace-ui-apps-core": "static-1.18658",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4619",
  "foundations-components-test-utils": "static-1.5623",
  "quartz-i18n": "static-1.838",
  "react-input-autosize": "static-2.17",
  "ads-unified-auth-lib": "static-1.337",
  "google-sheets-integration-lib": "static-1.541",
  "microsoft-drive-integration-lib": "static-1.677",
  "slack-ui-library": "static-1.10502",
  "fsm": "static-1.3836",
  "customer-data-objects": "static-1.7786",
  "property-translator": "static-1.5504",
  "hs-locale-management": "static-1.160",
  "frontend-preferences-client": "static-1.8035",
  "hs-promise-utils": "static-1.5698",
  "hubspot-apollo-client": "static-1.4985",
  "integrations-error-boundary-lib": "static-1.13907",
  "integrations-tracking-lib": "static-1.5713",
  "native-integrations-shared-strings": "static-1.7890",
  "reselect": "static-2.16",
  "sanitize": "static-1.4583",
  "superstore": "static-1.4867",
  "ui-shepherd-react": "static-3.10334",
  "ai-settings-ui-library": "static-1.8054",
  "hub-http-janus": "static-1.843",
  "hubspotter-http": "static-1.4729",
  "immutable-less": "static-1.4760",
  "marketplace-ui-client-types": "static-1.17533",
  "nav-meta": "static-1.29907",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18140",
  "inbound-db-properties-service-client": "static-1.3923",
  "property-management-common": "static-1.5806",
  "ui-addon-iframeable": "static-1.9171",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.542",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.838",
  "quartz-test": "static-1.838",
  "quartz-tracking": "static-1.542",
  "trellis-components": "static-1.2202",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.173",
  "bender-build-tools": "static-1.3281",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21791",
  "ContentUtils": "static-1.68659",
  "customer-data-objects-ui-components": "static-1.13138",
  "sassPrefix": "static-1.158",
  "breeze-engine-core": "static-1.358",
  "breeze-onboarding-components": "static-1.220",
  "avatar-components": "static-1.2605",
  "customer-data-filters-ui": "static-1.40143",
  "customer-data-reference-ui-components": "static-1.13279",
  "embedded-academy-lib": "static-1.14685",
  "ExportDialog": "static-6.10487",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41565",
  "reporting-snowflake": "static-1.56590",
  "reporting-ui-components": "static-2.65243",
  "reporting-visualizations": "static-1.60048",
  "trellis-theming": "static-1.1048",
  "ui-addon-teams": "static-1.21689",
  "integrations-reconnect-lib": "static-1.160",
  "magpie-lib": "static-1.5622",
  "navigation-components": "static-1.18270",
  "breeze-engine-lib": "static-1.1080",
  "magpie-types": "static-1.5082",
  "simple-logging-lib": "static-1.3157",
  "ai-studio-lib": "static-1.11917",
  "app-governance-lib": "static-1.1882",
  "developer-experience-shared-components": "static-1.10621",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8112",
  "ui-product-approvals": "static-1.28572",
  "ui-tool-access": "static-1.10255",
  "usage-based-billing-components-lib": "static-1.9381",
  "usage-tracker-anonymous": "static-1.5873",
  "usage-tracker-public": "static-1.7267",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3664",
  "persist-promise": "static-1.3806",
  "reference-resolvers": "static-1.8281",
  "ui-extensibility-client-types": "static-1.4032",
  "hubspot-apollo-cache": "static-1.444",
  "universal-page-editor-lib": "static-1.3125",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3069",
  "atom": "static-1.5181",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6076",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1649",
  "crm-component-utils": "static-1.39352",
  "crm-properties-common-lib": "static-1.5996",
  "customer-data-properties": "static-1.51933",
  "framework-data-schema-resolvers": "static-1.6999",
  "property-value-citations": "static-1.2547",
  "reference-resolvers-lite": "static-1.8205",
  "ui-business-units-lib": "static-1.9169",
  "navigation-messaging": "static-1.7597",
  "hubspotter-http-shared-msw-handlers": "static-1.10217",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4921",
  "content-icons-ui": "static-1.2256",
  "customer-data-ui-utilities": "static-1.9932",
  "conversations-skeleton-state": "static-1.7355",
  "crm-message-bus": "static-1.43249",
  "customer-data-filters-ui-msw-helpers": "static-1.22578",
  "events-data-lib": "static-1.339",
  "FormUrlGenerator": "static-2.4828",
  "framework-builder-read-service-client": "static-1.4082",
  "framework-data-schema-quick-fetch": "static-1.6904",
  "multi-account-reference-resolvers": "static-1.1089",
  "onboarding-tours": "static-1.16798",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13976",
  "academy-common-lib": "static-1.14145",
  "content-assistance-lib": "static-1.7921",
  "dashboard-lib": "static-1.81934",
  "file-manager-components": "static-1.23906",
  "getting-started-shared-tasks": "static-1.18701",
  "hubspot-prosemirror": "static-1.18519",
  "hubspot-prosemirror-plugins": "static-1.18511",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20014",
  "share-with-third-party-component-lib": "static-1.8812",
  "ui-addon-draggable": "static-3.4867",
  "ui-asset-management-lib": "static-1.11169",
  "user-context": "static-1.5217",
  "growth-payments-core": "static-1.25682",
  "reporting-plugins": "static-1.10496",
  "reporting-reports": "static-1.67650",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.832",
  "nest": "static-1.339",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10734",
  "framework-listing-lib": "static-2.28985",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30960",
  "apps-service-types": "static-1.3910",
  "oauth-service-types": "static-1.4360",
  "react-dnd-compat": "static-1.4722",
  "ui-product-approvals-common": "static-1.467",
  "onboarding-scopes": "static-1.6568",
  "onboarding-tours-client": "static-1.5012",
  "platform-infra-nav-components": "static-1.7750",
  "subscription-experience-data-types": "static-1.15057",
  "crm-record-cards-service-types": "static-1.3667",
  "location-customization-utils-lib": "static-1.9564",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6079",
  "signup-constants": "static-1.19091",
  "signup-ui-url-generator": "static-2.8164",
  "card-properties-lib": "static-1.44504",
  "commerce-subscription-lib": "static-1.37391",
  "crm-actions": "static-1.6446",
  "crm-cards-sdk": "static-1.43887",
  "customer-data-properties-shared-msw-handlers": "static-1.9546",
  "customer-data-tracking": "static-1.6996",
  "hs-resources": "static-1.280",
  "pulse": "static-1.703",
  "calling-global-api": "static-1.64868",
  "calling-internal-common": "static-1.31417",
  "calling-lifecycle-internal": "static-1.66250",
  "calling-lifecycle-messages": "static-1.58544",
  "commerce-products-lib": "static-1.9935",
  "conditional-properties-service-client": "static-1.3874",
  "crm-links": "static-1.6415",
  "crm-pipelines-api-client-types": "static-1.4216",
  "external-options-client-types": "static-1.4207",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4295",
  "meetings-icalendar-utils-lib": "static-1.741",
  "multi-currency-client-types": "static-1.3768",
  "object-builder-ui-client": "static-1.49102",
  "pipeline-validation-client-types": "static-1.4044",
  "smart-property-lib": "static-1.7744",
  "tiered-pricing": "static-1.1484",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11096",
  "fdsr-migration-layer": "static-1.118",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1140",
  "growth-data-modal": "static-1.5596",
  "growth-onboarding-confetti": "static-1.3172",
  "growth-onboarding-next-action-utils": "static-1.2222",
  "onboarding-tours-utils": "static-1.864",
  "ui-shepherd-tracker": "static-1.7715",
  "academy-service-client": "static-1.3791",
  "SafeStorage": "static-1.4506",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39405",
  "FileManagerLib": "static-1.39546",
  "video-embed": "static-1.36107",
  "ui-coaching-tips": "static-1.28849",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11615",
  "video-data-lib": "static-1.35273",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23797",
  "ui-addon-emoji-picker": "static-1.9994",
  "EmailSignatureEditor": "static-1.24602",
  "viral-links-lib": "static-1.7176",
  "data-token-picker": "static-1.16593",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.330",
  "timezone-utils": "static-2.5350",
  "seat-types-lib": "static-1.254",
  "getting-started-shared-tasks-store": "static-1.17819",
  "ui-addon-opt": "static-4.8468",
  "campaign-roi-lib": "static-1.9395",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25662",
  "framework-data-table": "static-2.12153",
  "marketing-platform-lib": "static-1.6973",
  "nudge-client-utils": "static-1.2801",
  "nudge-custom-ui-functions": "static-1.1213",
  "switchboard-lib": "static-1.331",
  "app-users-service-client": "static-1.5715",
  "app-users-service-types": "static-1.5123",
  "mini-checkout-client": "static-1.27068",
  "onboarding-utils": "static-1.5466",
  "permissions-shared-i18n-strings-fe": "static-1.2061",
  "ui-coaching-tips-shared-config": "static-1.28834",
  "edison-service-client-types": "static-1.496",
  "crm_data": "static-4.92284",
  "customer-data-sidebar": "static-2.46300",
  "enrichment-properties-lib": "static-1.16862",
  "ui-addon-draggable-compat": "static-2.4366",
  "universal-record-utils-lib": "static-1.1208",
  "commerce-billing-lib": "static-1.19416",
  "commerce-shared-components-lib": "static-1.18783",
  "commerce-tools-ui-lib": "static-1.10655",
  "crm-fe-perf": "static-1.23011",
  "event-emitter": "static-1.1057",
  "bend-plugin-pulse": "static-1.206",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31424",
  "shared-worker-versioning": "static-1.11142",
  "calling-usage-tracker": "static-1.6650",
  "voice-sms-access-library": "static-1.1404",
  "commerce-permissions": "static-1.884",
  "products-iframe-lib": "static-1.8222",
  "products-ui-components-shared-msw-handlers": "static-1.10601",
  "data-agent-kit": "static-1.366",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10302",
  "policy-lib": "static-1.6889",
  "react-tinymce": "static-1.55517",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10365",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54643",
  "tinymce-plugins": "static-1.57757",
  "tinymce-themes": "static-1.56613",
  "onboarding-data-sync-lib": "static-1.2141",
  "growth-onboarding-next-action-components": "static-1.2250",
  "user-context-client": "static-1.4688",
  "audio-components": "static-1.6078",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37057",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4643",
  "video-components": "static-1.13617",
  "outpost": "static-1.4277",
  "growth-onboarding-feedback-components": "static-1.6686",
  "content-media-composition-data-lib": "static-1.12641",
  "content-media-compositions": "static-2.16648",
  "media-bridge-lib": "static-1.19109",
  "commerce-tours-lib": "static-1.6292",
  "growth-onboarding-reliability": "static-1.5188",
  "sales-checkout-service-client": "static-1.3700",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21861",
  "sales-email-signature-service-client": "static-1.3956",
  "ts-utils-lib": "static-1.279",
  "crm-export-dialog": "static-1.6392",
  "crm-index-associations-lib": "static-1.6548",
  "crm-view-components": "static-1.590",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7437",
  "nudge-custom-function-registry": "static-1.2558",
  "nudge-renderer-utils": "static-1.2877",
  "whisper-core-api": "static-1.6849",
  "InboxConnectUtils": "static-4.15084",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5779",
  "settings-content-modals": "static-1.46375",
  "crm_universal": "static-1.22193",
  "customer-data-email": "static-1.18222",
  "card-payment-highlight-lib": "static-1.37465",
  "card-subscription-highlight-lib": "static-1.39814",
  "commerce-contract-lib": "static-1.12569",
  "invoices-highlight-card-lib": "static-1.55064",
  "orders-highlight-card-lib": "static-1.21752",
  "products-highlight-card-lib": "static-1.18218",
  "quotes-highlight-card-lib": "static-1.72361",
  "crm-source-interpretation-lib": "static-1.5450",
  "crm-object-search-query-utilities": "static-1.9815",
  "utility-belt": "static-1.2640",
  "payments-enrollment-embed-lib": "static-1.23218",
  "stripe-embedded-components": "static-1.7695",
  "customer-data-rte": "static-1.33268",
  "cv-backend-services": "static-1.1558",
  "growth-onboarding-empty-states": "static-1.5933",
  "payments-post-enroll-local-storage-lib": "static-1.5213",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38451",
  "trials-service-types": "static-1.3989",
  "calling-orchestration-schema": "static-1.36181",
  "sales-views-client-types": "static-1.4363",
  "hub-http-contrib": "static-1.3150",
  "interframe": "static-3.4867",
  "tinymce-data": "static-1.40728",
  "ui-addon-sales-email": "static-1.5317",
  "layout-dnd-components": "static-1.12647",
  "layout-dnd-utils": "static-1.11622",
  "ui-brand-identity-lib": "static-1.15649",
  "NamespacedHubStyle": "static-2.9134",
  "meetings-connect-utils-lib": "static-1.7711",
  "social-insights-client-types": "static-1.22323",
  "js-cookie": "static-1.18",
  "crm-index-visualization-core": "static-1.4274",
  "checkout-sdk": "static-3.23911",
  "checkout-service-types": "static-1.3875",
  "company-details-components": "static-1.6304",
  "payment-method-components": "static-1.6980",
  "pricing-pages-ui-components": "static-1.14661",
  "quote-checkout-service-types": "static-1.3571",
  "upgrade-catalog-service-types": "static-1.3629",
  "access-control-lib": "static-1.10541",
  "EmailComponents": "static-1.55053",
  "EmailData": "static-1.53730",
  "redux-less": "static-2.9589",
  "sequences-lib": "static-1.8231",
  "ui-gdpr-components": "static-1.10458",
  "products-ui-components": "static-1.40453",
  "accounting-integrations-ui-components": "static-1.7236",
  "invoices-ui-lib": "static-1.55080",
  "commerce-products-api": "static-1.2447",
  "invoices-iframe-lib": "static-1.57138",
  "quotes-modal-lib": "static-1.103039",
  "quotes-ui-lib": "static-1.81082",
  "stripe-connect-js": "static-1.70",
  "draft-content-plugins": "static-1.28537",
  "ContentData": "static-1.68734",
  "layout-data-lib": "static-1.9947",
  "hub-http-rxjs": "static-1.808",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4044",
  "billing-payments-client-types": "static-1.4098",
  "react-performance-metrics-lib": "static-1.663",
  "account-and-billing-fintech-outages": "static-3.18711",
  "pricing-pages-api": "static-1.14526",
  "ContentComponents": "static-2.71615",
  "marketing-contacts-lib": "static-1.10391",
  "marketing-email-service-types": "static-1.1983",
  "messaging-editing-lib": "static-1.46564",
  "messaging-usage-based-billing-components-lib": "static-1.1426",
  "automation-ui-source-apps": "static-1.19182",
  "automation-ui-types": "static-1.20100",
  "messaging-types-lib": "static-1.46301",
  "onboarding-settings-client": "static-1.4609",
  "sequences-client-types-lib": "static-1.8088",
  "commerce-tax-lib": "static-1.643",
  "price-books-api": "static-1.1206",
  "price-books-components": "static-1.1264",
  "property-description-translator": "static-1.3948",
  "ramp-editor": "static-1.418",
  "commerce-analytics-service-client": "static-1.3688",
  "totals-ui-components": "static-1.23880",
  "SalesContentIndexUI": "static-3.9394",
  "advanced-menus-core": "static-1.15298",
  "advanced-menus-lib": "static-1.12212",
  "ui-memberships-settings-lib": "static-1.34325",
  "segments-query-core": "static-1.1527",
  "automation-ui-ubb": "static-1.6016",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7445",
  "data-token-views": "static-1.16574",
  "forms-utils-lib": "static-1.12780",
  "payments-embed-points-lib": "static-1.13250",
  "simple-menus-core": "static-1.15297",
  "simple-menus-lib": "static-1.16814",
  "videoconference-integration-components": "static-1.6970",
  "marketing-contacts-client": "static-1.7620",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2630",
  "ContentEditorUI": "static-2.77400",
  "short-messages-app-service-client": "static-1.4031",
  "web-interactives-components": "static-1.13945",
  "web-interactives-data": "static-1.13946",
  "messaging-shared-utils-lib": "static-1.875",
  "messaging-user-info-utils-lib": "static-1.1045",
  "email-portal-health-service-types": "static-1.1083",
  "line-items-api": "static-1.849",
  "commerce-totals-service-types": "static-1.3896",
  "FireAlarmUi": "static-1.4586",
  "sales-templates-service-types-lib": "static-1.4247",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22036",
  "automation-ui-usage-tracking": "static-1.21499",
  "data-studio-ubb": "static-1.3020",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27257",
  "collaboration-sidebar": "static-1.58149",
  "content-management-data-lib": "static-1.5582",
  "copilot-plugins": "static-1.11374",
  "cta-picker": "static-1.36674",
  "customer-agent-discovery-components-lib": "static-1.3384",
  "editor-components": "static-1.13380",
  "editor-iframe-lib": "static-1.8547",
  "error-messaging-js": "static-1.5298",
  "FormsCommonComponents": "static-1.86111",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10753",
  "SharedLegalStrings": "static-1.1853",
  "smart-content-core": "static-1.42721",
  "smart-content-lib": "static-1.43374",
  "social-composer-lib": "static-1.59529",
  "structured-content-lib": "static-1.25465",
  "theme-previewer-lib": "static-1.53525",
  "tinymce-copilot": "static-1.16711",
  "xray-recommendation-lib": "static-1.8044",
  "automation-ui-routing": "static-1.21457",
  "sql-reporting-client-types": "static-1.5723",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42417",
  "campaigns-utils-lib": "static-1.3296",
  "reporting-enablement": "static-1.23281",
  "chatspot-widget-iframe": "static-1.21782",
  "collaboration-sidebar-common": "static-1.2946",
  "forms-ai-lib": "static-1.4484",
  "codemirror-dlb": "static-1.58959",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6543",
  "report-customization-components": "static-1.13453",
  "data-quality-ui-library": "static-1.13304",
  "reporting-filters": "static-1.580",
  "reporting-insights-lib": "static-1.2045"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12697",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9769",
  "foundations-components": "/foundations-components/static-1.8140",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1165",
  "foundations-theming": "/foundations-theming/static-1.4537",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8125",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10219",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11582",
  "I18n": "/I18n/static-7.1636",
  "jasmine-runner": "/jasmine-runner/static-1.6565",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12760",
  "quartz": "/quartz/static-1.7163",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16789",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2965",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9905",
  "settings-ui-lib": "/settings-ui-lib/static-1.12627",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7329",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11256",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9645",
  "unified-auth": "/unified-auth/static-1.619",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.901",
  "usage-tracker": "/usage-tracker/static-1.7456",
  "usage-tracker-core": "/usage-tracker-core/static-1.7306",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8202",
  "hub-http": "/hub-http/static-1.6330",
  "integrations-lib": "/integrations-lib/static-1.16492",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20126",
  "property-management-iframe": "/property-management-iframe/static-1.13518",
  "quartz-config": "/quartz-config/static-1.941",
  "quartz-core": "/quartz-core/static-1.6382",
  "quartz-routing": "/quartz-routing/static-1.593",
  "quick-fetch": "/quick-fetch/static-1.3995",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4763",
  "ts-schema": "/ts-schema/static-1.4158",
  "ui-universal-auth": "/ui-universal-auth/static-1.9105",
  "UIComponents": "/UIComponents/static-3.8528",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3475",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3440",
  "quartz-webpack": "/quartz-webpack/static-1.3387",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.241",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4409",
  "floating-ui": "/floating-ui/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4980",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2253",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9529",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.34",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5420",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2183",
  "ui-fonts": "/ui-fonts/static-1.844",
  "ui-images": "/ui-images/static-2.1179",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3020",
  "foundations-theming-base": "/foundations-theming-base/static-1.3522",
  "stylex": "/stylex/static-1.34",
  "HeadJS": "/HeadJS/static-2.767",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3236",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4433",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9214",
  "ai-rendering-library": "/ai-rendering-library/static-1.10541",
  "chirp-fetch": "/chirp-fetch/static-1.1994",
  "connections-embed-lib": "/connections-embed-lib/static-1.1187",
  "copilot-toolkit": "/copilot-toolkit/static-1.11401",
  "feedback-loader": "/feedback-loader/static-1.29492",
  "laboratory-lib": "/laboratory-lib/static-3.7259",
  "marketplace-embed": "/marketplace-embed/static-1.22421",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10021",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20081",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14296",
  "sanitize-text": "/sanitize-text/static-1.8252",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8810",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5870",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5142",
  "wootric-nps": "/wootric-nps/static-1.7061",
  "quartz-head": "/quartz-head/static-1.828",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4759",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4258",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2564",
  "reporting-data": "/reporting-data/static-1.67972",
  "cssUtils": "/cssUtils/static-1.822",
  "flux-actions": "/flux-actions/static-1.345",
  "HubStyle": "/HubStyle/static-2.11889",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10315",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10469",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7446",
  "icons": "/icons/static-2.653",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18658",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4619",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5623",
  "quartz-i18n": "/quartz-i18n/static-1.838",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.337",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.541",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.677",
  "slack-ui-library": "/slack-ui-library/static-1.10502",
  "fsm": "/fsm/static-1.3836",
  "customer-data-objects": "/customer-data-objects/static-1.7786",
  "property-translator": "/property-translator/static-1.5504",
  "hs-locale-management": "/hs-locale-management/static-1.160",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8035",
  "hs-promise-utils": "/hs-promise-utils/static-1.5698",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4985",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13907",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5713",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7890",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4583",
  "superstore": "/superstore/static-1.4867",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10334",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8054",
  "hub-http-janus": "/hub-http-janus/static-1.843",
  "hubspotter-http": "/hubspotter-http/static-1.4729",
  "immutable-less": "/immutable-less/static-1.4760",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17533",
  "nav-meta": "/nav-meta/static-1.29907",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18140",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3923",
  "property-management-common": "/property-management-common/static-1.5806",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9171",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.542",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.838",
  "quartz-test": "/quartz-test/static-1.838",
  "quartz-tracking": "/quartz-tracking/static-1.542",
  "trellis-components": "/trellis-components/static-1.2202",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.173",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21791",
  "ContentUtils": "/ContentUtils/static-1.68659",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13138",
  "sassPrefix": "/sassPrefix/static-1.158",
  "breeze-engine-core": "/breeze-engine-core/static-1.358",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.220",
  "avatar-components": "/avatar-components/static-1.2605",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40143",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13279",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14685",
  "ExportDialog": "/ExportDialog/static-6.10487",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41565",
  "reporting-snowflake": "/reporting-snowflake/static-1.56590",
  "reporting-ui-components": "/reporting-ui-components/static-2.65243",
  "reporting-visualizations": "/reporting-visualizations/static-1.60048",
  "trellis-theming": "/trellis-theming/static-1.1048",
  "ui-addon-teams": "/ui-addon-teams/static-1.21689",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.160",
  "magpie-lib": "/magpie-lib/static-1.5622",
  "navigation-components": "/navigation-components/static-1.18270",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1080",
  "magpie-types": "/magpie-types/static-1.5082",
  "simple-logging-lib": "/simple-logging-lib/static-1.3157",
  "ai-studio-lib": "/ai-studio-lib/static-1.11917",
  "app-governance-lib": "/app-governance-lib/static-1.1882",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10621",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8112",
  "ui-product-approvals": "/ui-product-approvals/static-1.28572",
  "ui-tool-access": "/ui-tool-access/static-1.10255",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9381",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5873",
  "usage-tracker-public": "/usage-tracker-public/static-1.7267",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3664",
  "persist-promise": "/persist-promise/static-1.3806",
  "reference-resolvers": "/reference-resolvers/static-1.8281",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4032",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.444",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3125",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3069",
  "atom": "/atom/static-1.5181",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6076",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1649",
  "crm-component-utils": "/crm-component-utils/static-1.39352",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5996",
  "customer-data-properties": "/customer-data-properties/static-1.51933",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6999",
  "property-value-citations": "/property-value-citations/static-1.2547",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8205",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9169",
  "navigation-messaging": "/navigation-messaging/static-1.7597",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10217",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4921",
  "content-icons-ui": "/content-icons-ui/static-1.2256",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9932",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7355",
  "crm-message-bus": "/crm-message-bus/static-1.43249",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22578",
  "events-data-lib": "/events-data-lib/static-1.339",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4828",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4082",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6904",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1089",
  "onboarding-tours": "/onboarding-tours/static-1.16798",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13976",
  "academy-common-lib": "/academy-common-lib/static-1.14145",
  "content-assistance-lib": "/content-assistance-lib/static-1.7921",
  "dashboard-lib": "/dashboard-lib/static-1.81934",
  "file-manager-components": "/file-manager-components/static-1.23906",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18701",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18519",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18511",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20014",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8812",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4867",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11169",
  "user-context": "/user-context/static-1.5217",
  "growth-payments-core": "/growth-payments-core/static-1.25682",
  "reporting-plugins": "/reporting-plugins/static-1.10496",
  "reporting-reports": "/reporting-reports/static-1.67650",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.832",
  "nest": "/nest/static-1.339",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10734",
  "framework-listing-lib": "/framework-listing-lib/static-2.28985",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30960",
  "apps-service-types": "/apps-service-types/static-1.3910",
  "oauth-service-types": "/oauth-service-types/static-1.4360",
  "react-dnd-compat": "/react-dnd-compat/static-1.4722",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.467",
  "onboarding-scopes": "/onboarding-scopes/static-1.6568",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5012",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7750",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15057",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3667",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9564",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6079",
  "signup-constants": "/signup-constants/static-1.19091",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8164",
  "card-properties-lib": "/card-properties-lib/static-1.44504",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37391",
  "crm-actions": "/crm-actions/static-1.6446",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43887",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9546",
  "customer-data-tracking": "/customer-data-tracking/static-1.6996",
  "hs-resources": "/hs-resources/static-1.280",
  "pulse": "/pulse/static-1.703",
  "calling-global-api": "/calling-global-api/static-1.64868",
  "calling-internal-common": "/calling-internal-common/static-1.31417",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66250",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58544",
  "commerce-products-lib": "/commerce-products-lib/static-1.9935",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3874",
  "crm-links": "/crm-links/static-1.6415",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4216",
  "external-options-client-types": "/external-options-client-types/static-1.4207",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4295",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.741",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3768",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49102",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4044",
  "smart-property-lib": "/smart-property-lib/static-1.7744",
  "tiered-pricing": "/tiered-pricing/static-1.1484",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11096",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.118",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1140",
  "growth-data-modal": "/growth-data-modal/static-1.5596",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3172",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2222",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.864",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7715",
  "academy-service-client": "/academy-service-client/static-1.3791",
  "SafeStorage": "/SafeStorage/static-1.4506",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39405",
  "FileManagerLib": "/FileManagerLib/static-1.39546",
  "video-embed": "/video-embed/static-1.36107",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28849",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11615",
  "video-data-lib": "/video-data-lib/static-1.35273",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23797",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9994",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24602",
  "viral-links-lib": "/viral-links-lib/static-1.7176",
  "data-token-picker": "/data-token-picker/static-1.16593",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.330",
  "timezone-utils": "/timezone-utils/static-2.5350",
  "seat-types-lib": "/seat-types-lib/static-1.254",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17819",
  "ui-addon-opt": "/ui-addon-opt/static-4.8468",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9395",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25662",
  "framework-data-table": "/framework-data-table/static-2.12153",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6973",
  "nudge-client-utils": "/nudge-client-utils/static-1.2801",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1213",
  "switchboard-lib": "/switchboard-lib/static-1.331",
  "app-users-service-client": "/app-users-service-client/static-1.5715",
  "app-users-service-types": "/app-users-service-types/static-1.5123",
  "mini-checkout-client": "/mini-checkout-client/static-1.27068",
  "onboarding-utils": "/onboarding-utils/static-1.5466",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2061",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28834",
  "edison-service-client-types": "/edison-service-client-types/static-1.496",
  "crm_data": "/crm_data/static-4.92284",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46300",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16862",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4366",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1208",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19416",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18783",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10655",
  "crm-fe-perf": "/crm-fe-perf/static-1.23011",
  "event-emitter": "/event-emitter/static-1.1057",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.206",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31424",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11142",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6650",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1404",
  "commerce-permissions": "/commerce-permissions/static-1.884",
  "products-iframe-lib": "/products-iframe-lib/static-1.8222",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10601",
  "data-agent-kit": "/data-agent-kit/static-1.366",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10302",
  "policy-lib": "/policy-lib/static-1.6889",
  "react-tinymce": "/react-tinymce/static-1.55517",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10365",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54643",
  "tinymce-plugins": "/tinymce-plugins/static-1.57757",
  "tinymce-themes": "/tinymce-themes/static-1.56613",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2141",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2250",
  "user-context-client": "/user-context-client/static-1.4688",
  "audio-components": "/audio-components/static-1.6078",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37057",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4643",
  "video-components": "/video-components/static-1.13617",
  "outpost": "/outpost/static-1.4277",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6686",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12641",
  "content-media-compositions": "/content-media-compositions/static-2.16648",
  "media-bridge-lib": "/media-bridge-lib/static-1.19109",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6292",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5188",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3700",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21861",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3956",
  "ts-utils-lib": "/ts-utils-lib/static-1.279",
  "crm-export-dialog": "/crm-export-dialog/static-1.6392",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6548",
  "crm-view-components": "/crm-view-components/static-1.590",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7437",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2558",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2877",
  "whisper-core-api": "/whisper-core-api/static-1.6849",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15084",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5779",
  "settings-content-modals": "/settings-content-modals/static-1.46375",
  "crm_universal": "/crm_universal/static-1.22193",
  "customer-data-email": "/customer-data-email/static-1.18222",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37465",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39814",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12569",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55064",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21752",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18218",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72361",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5450",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9815",
  "utility-belt": "/utility-belt/static-1.2640",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23218",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7695",
  "customer-data-rte": "/customer-data-rte/static-1.33268",
  "cv-backend-services": "/cv-backend-services/static-1.1558",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5933",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5213",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38451",
  "trials-service-types": "/trials-service-types/static-1.3989",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36181",
  "sales-views-client-types": "/sales-views-client-types/static-1.4363",
  "hub-http-contrib": "/hub-http-contrib/static-1.3150",
  "interframe": "/interframe/static-3.4867",
  "tinymce-data": "/tinymce-data/static-1.40728",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5317",
  "layout-dnd-components": "/layout-dnd-components/static-1.12647",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11622",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15649",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9134",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7711",
  "social-insights-client-types": "/social-insights-client-types/static-1.22323",
  "js-cookie": "/js-cookie/static-1.18",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4274",
  "checkout-sdk": "/checkout-sdk/static-3.23911",
  "checkout-service-types": "/checkout-service-types/static-1.3875",
  "company-details-components": "/company-details-components/static-1.6304",
  "payment-method-components": "/payment-method-components/static-1.6980",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14661",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3571",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3629",
  "access-control-lib": "/access-control-lib/static-1.10541",
  "EmailComponents": "/EmailComponents/static-1.55053",
  "EmailData": "/EmailData/static-1.53730",
  "redux-less": "/redux-less/static-2.9589",
  "sequences-lib": "/sequences-lib/static-1.8231",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10458",
  "products-ui-components": "/products-ui-components/static-1.40453",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7236",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55080",
  "commerce-products-api": "/commerce-products-api/static-1.2447",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57138",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103039",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81082",
  "stripe-connect-js": "/stripe-connect-js/static-1.70",
  "draft-content-plugins": "/draft-content-plugins/static-1.28537",
  "ContentData": "/ContentData/static-1.68734",
  "layout-data-lib": "/layout-data-lib/static-1.9947",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.808",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4044",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4098",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.663",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18711",
  "pricing-pages-api": "/pricing-pages-api/static-1.14526",
  "ContentComponents": "/ContentComponents/static-2.71615",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10391",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1983",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46564",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1426",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19182",
  "automation-ui-types": "/automation-ui-types/static-1.20100",
  "messaging-types-lib": "/messaging-types-lib/static-1.46301",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4609",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8088",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.643",
  "price-books-api": "/price-books-api/static-1.1206",
  "price-books-components": "/price-books-components/static-1.1264",
  "property-description-translator": "/property-description-translator/static-1.3948",
  "ramp-editor": "/ramp-editor/static-1.418",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3688",
  "totals-ui-components": "/totals-ui-components/static-1.23880",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9394",
  "advanced-menus-core": "/advanced-menus-core/static-1.15298",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12212",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34325",
  "segments-query-core": "/segments-query-core/static-1.1527",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6016",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7445",
  "data-token-views": "/data-token-views/static-1.16574",
  "forms-utils-lib": "/forms-utils-lib/static-1.12780",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13250",
  "simple-menus-core": "/simple-menus-core/static-1.15297",
  "simple-menus-lib": "/simple-menus-lib/static-1.16814",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6970",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7620",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2630",
  "ContentEditorUI": "/ContentEditorUI/static-2.77400",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4031",
  "web-interactives-components": "/web-interactives-components/static-1.13945",
  "web-interactives-data": "/web-interactives-data/static-1.13946",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.875",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1045",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1083",
  "line-items-api": "/line-items-api/static-1.849",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3896",
  "FireAlarmUi": "/FireAlarmUi/static-1.4586",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4247",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22036",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21499",
  "data-studio-ubb": "/data-studio-ubb/static-1.3020",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27257",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58149",
  "content-management-data-lib": "/content-management-data-lib/static-1.5582",
  "copilot-plugins": "/copilot-plugins/static-1.11374",
  "cta-picker": "/cta-picker/static-1.36674",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3384",
  "editor-components": "/editor-components/static-1.13380",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8547",
  "error-messaging-js": "/error-messaging-js/static-1.5298",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86111",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10753",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1853",
  "smart-content-core": "/smart-content-core/static-1.42721",
  "smart-content-lib": "/smart-content-lib/static-1.43374",
  "social-composer-lib": "/social-composer-lib/static-1.59529",
  "structured-content-lib": "/structured-content-lib/static-1.25465",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53525",
  "tinymce-copilot": "/tinymce-copilot/static-1.16711",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8044",
  "automation-ui-routing": "/automation-ui-routing/static-1.21457",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5723",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42417",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3296",
  "reporting-enablement": "/reporting-enablement/static-1.23281",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21782",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2946",
  "forms-ai-lib": "/forms-ai-lib/static-1.4484",
  "codemirror-dlb": "/codemirror-dlb/static-1.58959",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6543",
  "report-customization-components": "/report-customization-components/static-1.13453",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13304",
  "reporting-filters": "/reporting-filters/static-1.580",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2045"
}
};
